import { Add, Button, PageHeader } from '@lmc/ui-kit'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import { useState } from 'react'
import styled from 'styled-components'
import { RotaPatternModal } from '../RotaPattern'
import NewRotaPatternModal from '../RotaPattern/NewRotaPatternModal/NewRotaPatternModal'
import RotaShiftsTable from '../RotaPattern/RotaShiftsTable'

export const RotaManageShiftsScreen = () => {
  const { hasRota } = useHomeType()

  const flags = useFeatureFlags({
    flagNames: ['new_create_pattern']
  })?.data

  const flagsNewCreatePatternEnabled = flags?.new_create_pattern?.enabled

  const [patternModalVisible, setPatternModalVisible] = useState(false)

  if (!hasRota) {
    return null
  }
  const hasBanner = true

  return (
    <Container hasBanner={hasBanner}>
      <PageHeader title="Manage Shifts">
        <Button variant="primary" onClick={() => setPatternModalVisible(true)}>
          <Add />
          Add a shift
        </Button>
      </PageHeader>
      {patternModalVisible &&
        (flagsNewCreatePatternEnabled ? (
          <NewRotaPatternModal
            onCancel={() => setPatternModalVisible(false)}
            type="shift"
          />
        ) : (
          <RotaPatternModal
            type="shift"
            patternModalVisible={patternModalVisible}
            onCancel={() => setPatternModalVisible(false)}
          />
        ))}
      <RotaShiftsTable />
    </Container>
  )
}

const Container = styled.div<{ hasBanner?: boolean }>`
  padding: 0px 48px;
  padding: ${(props) => (props.hasBanner ? '0px 48px' : `24px 48px`)};
  display: flex;
  flex-direction: column;
  gap: 12px;
`
